<template>
    <div>
        <app-tabela
            idTabela="tblMensRascunhos"
            :itens="mensagens"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
        >
            <template slot="acoes" slot-scope="data">
                <span class="text-primary">
                    <i
                        class="fa fa-edit fa-lg icon-button"
                        title="Atualizar"
                        @click.stop="atualizarMensagem(data.mensagemId)"
                    ></i>
                </span>
                <excluir
                    :mensagem="data"
                    @obterMensagensAtualizadas="$emit('obterMensagensAtualizadas')"
                ></excluir>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import Excluir from './Excluir'

export default {
	props: {
		mensagens: {
			type: Array,
			default: () => []
		}
	},

	components: { Excluir },

	data() {
		return {
			campos: [
				{
					key: 'criadaPor',
					label: 'Criada por',
					sortable: true,
					filterable: true
				},
				{
					key: 'assunto',
					label: 'Assunto',
					sortable: true,
					filterable: true
				},
				{
					key: 'dataCadastro',
					label: 'Criada em',
					sortable: true,
					type: 'datetime'
				},
				{
					key: 'acoes',
					label: 'Ações'
				}
			],
			itensPorPagina: 10
		}
	},

	methods: {
		atualizarMensagem(id) {
			this.$router.push({
				name: 'Mensagens_Detalhar',
				params: {
					mensagemId: id
				}
			})
		}
	},

	created() {},

	computed: {},

	watch: {}
}
</script>
